<template>
	<div class='forgot_wrap'>
		<!-- <div class="promp-box">
			<h1>Kindly send an email to teach@51talk.com to reset your password</h1>
		</div> -->
		<div class="table_container">
			<h1>Reset your password</h1>
			<p class='wrong' v-show='wrong_state'>{{wrong_words}}</p>
			<div class='input'>
				<input type="text" v-model.trim='email' placeholder="Email Adress" @blur='check_val'>
			</div>

			<div class="clearfix btns">
				<a class='continue' @click='next_reset'>Continue</a>
				<a class="cancel" @click='back_login'>Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      wrong_state: '',
      email: '',
      wrong_words: ''
    }
  },
  methods: {
    next_reset: function() {
			let _this = this
			_this.check_val()
      if (this.wrong_state !== false) return
      this.axios
        .get('/index/verifybyemail', {
          params: {
            email: _this.email
          }
        })
        .then(function(response) {
          if (response.data && response.data.code == '75000') {
            _this.$router.push('forgot_password_step2')
          } else {
            _this.wrong_words = response.data.message
            _this.wrong_state = true
          }
        })
    },
    back_login: function() {
      this.$router.go(-1)
    },
    check_val: function() {
      let rule = this.email.match(/^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/g)
      let _this = this
      if (!this.email) {
        this.wrong_state = true
        this.wrong_words = "Please don't leave email address blank!"
      } else if (rule == null) {
        this.wrong_state = true
        this.wrong_words = 'Email format is incorrect!'
      } else {
        window.localStorage.setItem('r_email', _this.email)
        this.wrong_state = false
      }
    }
  }
}
</script>

<style lang='less' scoped>
.forgot_wrap {
  height: 1000px;
  background: url('~@img/creat_acount_bg.jpg') no-repeat center
    center;
  .promp-box {
    position: relative;
    width: 766px;
    margin: 0 auto;
    padding-top: 255px;
    h1 {
      text-align: center;
      color: #ffffff;
      font-size: 38px;
    }
  }
  .table_container {
    position: relative;
    width: 366px;
    margin: 0 auto;
    padding-top: 255px;
    h1 {
      text-align: center;
      color: #ffffff;
      font-size: 38px;
    }
    p {
      position: absolute;
      left: 0;
      top: 270px;
      background: url('~@img/forgot_step_1.png') no-repeat 0 0;
      margin-top: 44px;
      padding-left: 26px;
      font-size: 15px;
      height: 20px;
      line-height: 20px;
      color: #fe0036;
      white-space: nowrap;
    }
    div.input {
      margin-top: 65px;
      padding-bottom: 13px;
      border-bottom: 1px solid #868685;
      input {
        background: transparent url('~@img/forgot_step_1.png')
          no-repeat 0 -21px;
        box-sizing: border-box;
        padding-left: 33px;
        outline: none;
        width: 100%;
        color: #fff;
      }
    }

    div.btns {
      padding-top: 47px;
      a {
        float: left;
        cursor: pointer;
        width: 170px;
        height: 46px;
        line-height: 46px;
        font-size: 24px;
        text-align: center;
        border-radius: 50px;
        background: #ffc000;
        color: #000000;
      }
      a.cancel {
        border: 1px solid #ffc000;
        background: transparent;
        color: #ffc000;
        margin-left: 19px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// forgot_password_step1.vue?1749fdb6